import { Component, computed, inject, Input, OnInit } from '@angular/core';
import { IPurchasesDTO } from '../../../../models/IPurchasesDTO';
import { DialogModule } from 'primeng/dialog';
import { ScrollTop } from 'primeng/scrolltop';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { IPurchasesResponse } from '../../../../models/IPurchasesResponse';
import { AuthService } from '../../../../services/authentication/auth.service';
import { PopoverModule } from 'primeng/popover';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { MyPurchasesService } from '../../../../services/bidder-community/my-purchases/my-purchases.service';
import { ToastMessageService } from '../../../../services/toast-message/toast-message.service';
import { ProgressSpinner } from 'primeng/progressspinner';
import { Subscription } from 'rxjs';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-my-purchases-page',
  imports: [DialogModule,
    ScrollTop,
    CommonModule,
    FontAwesomeModule,
    PopoverModule,
    SelectModule,
    ButtonModule,
    FormsModule,
    ProgressSpinner,
    RouterModule

  ],
  templateUrl: './my-purchases-page.component.html',
  styleUrl: './my-purchases-page.component.scss'
})
export class MyPurchasesPageComponent implements OnInit {

  @Input() purchasesResponse: IPurchasesResponse | null = null;

  private readonly authService = inject(AuthService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly myPurchasesService = inject(MyPurchasesService);
  private readonly messageService = inject(ToastMessageService);

  public selectedPurchase: IPurchasesDTO | null = null;

  creditCards = this.authService.creditCardSignal;
  isAuthenticated = this.oidcSecurityService.authenticated;
  isLoadingPatch = this.myPurchasesService.isLoadingPatch;

  authSubscription!: Subscription;

  cardOptions = computed(() => {
    const data = this.authService.creditCardSignal();
    if (!data) return [];

    return data.creditCards.map(card => ({
      label: `${card.type} ****${card.lastDigits}`,
      value: card.id
    }))
  });

  showBackTop = false;
  faChevronUp = faChevronUp;
  selectedCard: number | null = null;
  // Modal 
  displayModal: boolean = false;

  ngOnInit(): void {

    //populate credit cards
    if (this.isAuthenticated().isAuthenticated && !this.authService.creditCardSignal()?.creditCards) {
      this.authService.getCreditCard().subscribe();
    }
  }

  onOpenModal(purchase: IPurchasesDTO) {

    if (purchase) {
      this.selectedPurchase = purchase;
      this.displayModal = true;
    }

  }
  onCloseModal() {

  }

  capitalize(text: string): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLocaleLowerCase();
  }

  labelPurchaseType(type: string): string {
    switch (type) {
      case 'ITEM':
        return 'Item';
      case 'CASH_DONATION':
        return 'Donation';
      case 'QUICK_SALE':
        return 'Quick sale';
      case 'TICKET':
        return 'Ticket';
      default:
        return "";
    }
  }

  onOpenPopover(event: Event, popover: any) {
    this.selectedCard = null;
    popover.toggle(event);
  }

  patchCreditCard(purchaseId: number) {
    this.myPurchasesService.patchCreditCard(purchaseId, this.selectedCard || 0).subscribe({
      next: () => {


        const cards = this.creditCards();
        const newCard = cards?.creditCards.find(c => c.id === this.selectedCard);
        const typeCard = newCard?.type;
        const cardDigits = newCard?.lastDigits;
        const index = this.purchasesResponse?.purchases.findIndex(b => b.purchaseId === purchaseId);

        if (index !== -1 && newCard) {

          this.purchasesResponse = {
            ...this.purchasesResponse,
            purchases: (this.purchasesResponse?.purchases ?? []).map(p =>
              p.purchaseId === purchaseId
                ? {
                  ...p,
                  cardType: typeCard ?? '',
                  cardEndDigits: cardDigits ?? ''
                }
                : p
            ),
            totalPurchases: this.purchasesResponse!.totalPurchases
          };
        }
      },
      error: (err) => {

        this.messageService.error(err.error.message || 'unknown error');
      }

    })
  }

}
